  import NiButton from "../button"

	
	export default{
    components:{
      NiButton,
    },
		props:{
      icon:{
        type:String,
      },
			right_open_width:{
				type:String,
				default:"70%"
			},
      right_open_height:{
				type:String,
				default:"99.32%"
			},
      right_open_top:{
				type:String,
				default:"2px"
			},
			visible:{
				type:Boolean,
				default:false,
			},

      beforeClose: Function,

      title:{
			  type:String,
				default:""
      },

      dialog_body_style: {},

      tool_show: {
        type: Boolean,
				default: true,
      },

		},
		data(){
			return {
				right_open_style:{},
        body_height: 500,
			}
		},
		watch:{
			visible(value){
				if(value){
					this.right_open_style ={
            "width": this.right_open_width,
            "height": this.right_open_height,
            "top": this.right_open_top
          }
          this.get_body_height()
				}else{
					this.right_open_style = {}
				}
				
			}
		},

    mounted(){
      this.get_body_height()
    },

    methods:{

      get_body_height(){
        this.$nextTick(() =>{
          this.body_height = this.$el.querySelector(".dialog-body").offsetHeight
          this.$emit("body_height_change", this.body_height)
        })
      },

      // 点击关闭按钮
      handle_close(){
        if (typeof this.beforeClose === 'function') {
          this.beforeClose(this.close);
        } else {
          this.close();
        }
      },

      // 关闭
      close(){
        this.$emit('update:visible', false);
      },
    },
	}



// WEBPACK FOOTER //
// ./src/ni-ui/dialog/dialog.js